export default __webpack_public_path__ + "static/media/tbl-prize3.ff5398f6.svg";